import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap5';
import * as Yup from 'yup';
import { Formik, Form as FormikForm } from 'formik';

import Footer from 'components/Widgets/Profile/FormFooter';
import HorizontalTextField from 'components/new_ui/Form/HorizontalTextField';
import { useContext as useUsersContext } from 'components/Users/Context';
import Actions from 'components/Affiliates/Profile/Actions';

export default function Password({ onCloseClick }) {
  const { dispatch: dispatchUsers, actions: actionsUsers, state: stateUsers } = useUsersContext();

  const affiliate = stateUsers.user.attributes.specific;

  const formSchema = Yup.object().shape({
    password: Yup.string().required('Password is required'),
    password_confirmation: Yup.string().typeError('Password confirmation is required'),
  });

  const onSubmitHundler = (values, { setSubmitting, setErrors }) => {
    Actions.update(
      affiliate.id,
      values,
      false,
      () => {
        setSubmitting(false);
        onCloseClick();
        actionsUsers.load(dispatchUsers);
      },
      (errors) => {
        const newErrors = {};
        errors.errors.forEach((item) => {
          newErrors[item.source.pointer.replace('/data/attributes/', '')] = item.detail;
        });
        setErrors(newErrors);
        setSubmitting(false);
      },
    );
  };

  return (
    <Formik
      validationSchema={formSchema}
      initialValues={{
        password: '',
        password_confirmation: '',
      }}
      onSubmit={onSubmitHundler}
    >
      {({ isSubmitting }) => (
        <FormikForm className="needs-validation" noValidate="">
          <Row>
            <Col>
              <HorizontalTextField type="password" name="password" label="Password" required />
            </Col>
          </Row>

          <Row>
            <Col>
              <HorizontalTextField type="password" name="password_confirmation" label="Confirm Password" required />
            </Col>
          </Row>

          <Footer loading={isSubmitting} onCancel={() => onCloseClick()} />
        </FormikForm>
      )}
    </Formik>
  );
}

Password.propTypes = {
  onCloseClick: PropTypes.func.isRequired,
};
